import { FramerPage } from 'Pages/FramerPage';

const Designers = () => <FramerPage path="designers" />;

export default Designers;
